
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Qrcode from 'vux/src/components/qrcode/index.vue'

export default {
name: 'user',
props: [],
components: {
XHeader,
Group,
Cell,
Qrcode
},
data () {
return {
userinfo: [
{
id: 0,
label: '姓名',
value: ''
},
{
id: 1,
label: '学院',
value: ''
},
{
id: 2,
label: '专业',
value: ''
},
{
id: 3,
label: '班级',
value: ''
},
{
id: 4,
label: '电话',
value: ''
},
{
id: 5,
label: 'E-mail',
value: ''
},
{
id: 6,
label: 'QQ',
value: ''
}
]
}
},
computed: {
title () {
return this.$route.meta.title
}
},
created () {
},
mounted () {
this.$vux.loading.show({
text: '加载中'
})
this.goUserInfo()
},
methods: {
back () {
setTimeout(() => {
this.$router.back(-1)
}, 300)
},
goUserInfo () {
this.$api.get('/user/afterLogin', null, r => {
this.$vux.loading.hide()
let info = r.data.studentBean
this.userinfo[0].value = info.name
this.userinfo[1].value = info.departmentName
this.userinfo[2].value = info.professionName
this.userinfo[3].value = info.className
this.userinfo[4].value = info.phoneNumber
this.userinfo[5].value = info.email
this.userinfo[6].value = info.qq
},
err => {
this.$vux.toast.text(err.message, 'middle')
})
}
}
}



// WEBPACK FOOTER //
// ./src/yingxin/tskjxy/views/user/userItem/userinfo.vue